import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=164e6e40&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "./Records.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Records.vue?vue&type=style&index=1&id=164e6e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e6e40",
  null
  
)

export default component.exports